/* ===================================================================
   MIcase · micase-ajustes-dawn.js
   Movido a assets/ el 2026-08-16 desde snippets/micase-ajustes-dawn.liquid.
   Antes iban cuatro bloques <script> en linea dentro del HTML de TODAS las
   paginas: ~24 KB que el navegador volvia a descargar en cada visita, sin
   caché posible. Aqui van como archivo, se cachean una vez y ya.
   Ninguno lleva Liquid, por eso se pueden sacar. El orden es el mismo que
   tenian en el snippet. Se carga con defer.
   NO esta aqui el bloque micase-ajustes-dawn-js (la insignia de
   compatibilidad): ese sigue en linea porque el servidor pinta la insignia
   VISIBLE con un modelo que puede no ser el elegido, y con defer el cliente
   veria un instante el modelo equivocado. Ver el snippet.
   =================================================================== */

/* ------------------------------------------------------------------
   1) micase-diseno-al-carrito
   ------------------------------------------------------------------ */
(function () {
  /* --------------------------------------------------------------------
     EL DISENO TIENE QUE LLEGAR AL CARRITO. 2026-08-09.

     El problema: el selector de diseno inyectaba su campo oculto buscando
     ".main-product form[action*=/cart/add]". Esa clase es de Glozin y en Dawn no existe,
     asi que el campo nunca se creaba. El cliente veia su diseno marcado y el pedido salia
     sin diseno. Nadie se entera hasta produccion.

     Y aunque se arreglara el selector, quedaria el segundo problema: Dawn rehace el
     formulario en cada cambio de variante, asi que un campo inyectado al cargar la pagina
     desaparece en cuanto el cliente cambia de modelo.

     La solucion no es reinyectar cada vez, es no depender de que el campo exista: se crea
     EN EL MOMENTO DEL ENVIO, leyendo el diseno marcado. Asi no hay nada que se pueda
     perder por el camino. Va en fase de captura para correr antes que el manejador de
     Dawn, que es quien serializa el formulario.
     -------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var accion = form.getAttribute('action') || '';
    if (accion.indexOf('/cart/add') === -1) return;

    var caja = document.querySelector('.mcdis');
    if (!caja) return;
    var elegido = document.querySelector('input[name="mc-diseno"]:checked');
    if (!elegido) return;

    var prop = caja.getAttribute('data-prop') || 'Diseno';
    var campo = form.querySelector('input[data-mcdis]');
    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.setAttribute('data-mcdis', '');
      form.appendChild(campo);
    }
    campo.name = 'properties[' + prop + ']';
    campo.value = elegido.value;
  }, true);
})();

/* ------------------------------------------------------------------
   2) micase-modelo-sync
   ------------------------------------------------------------------ */
(function () {
  /* --------------------------------------------------------------------
     EL MODELO ELEGIDO TIENE QUE LLEGAR A localStorage. 2026-08-10.

     EL FALLO, MEDIDO: con micase_modelo puesto a mano en {"n":"Xiaomi 14"...} y
     cambiando el selector a POCO F7 PRO, la variante pasa a 47249803641088 en los dos
     temas, pero en este tema micase_modelo se queda en Xiaomi 14. En el publicado si
     cambia. Consecuencia: micase-combo, micase-costo, micase-fotos y micase-similares
     LEEN ese valor antes que nada, asi que hoy hablan del modelo de otra visita. En una
     tienda de compatibilidad ese es el error caro.

     POR QUE FALTABA: quien lo mantenia era el bloque (7) de snippets/micase-fixes.liquid,
     que en este tema no lo renderiza nadie. Y aunque se renderizara no serviria: arranca
     con document.querySelector('.main-product'), que es clase de Glozin y aqui no existe.
     Por eso esto esta REESCRITO, no copiado.

     DE DONDE LEE: de lo mismo que lee Dawn. VariantSelects.getAllSelectedOptions()
     (assets/global.js) recorre 'fieldset, .product-form__input--dropdown' y toma
     checked.dataset.optionName. Se hace igual, con los mismos selectores, para que no
     pueda desalinearse del control que decide la variante. El buscador de modelo esconde
     el fieldset nativo por CSS pero no lo saca del DOM, asi que el radio marcado sigue
     ahi y se lee bien.

     COMO SE ENTERA DEL CAMBIO, y por que NO hay MutationObserver: Dawn ya vigila el
     selector, y encadenar otro observer sobre los mismos nodos colgo el navegador en la
     ficha de 96 variantes. Se usan dos vias baratas:
       1. Un listener de `change` delegado en document, filtrado por
          closest('variant-selects'). Es el evento que el propio VariantSelects escucha
          en su connectedCallback, asi que existe siempre y no depende de que
          window.subscribe o PUB_SUB_EVENTS esten publicados como globales.
       2. Los avisos que Dawn emite DESPUES de escribir input[name="id"], que es lo unico
          que decide que entra al carrito: variantChange, el `change` del propio input y
          'product-info:loaded'. Cubren el caso de que Dawn rehaga el formulario entero al
          repintar la seccion. (Hasta el 2026-08-22 esto era un sondeo cada 350 ms.)

     QUE NO HACE: no toca input[name="id"], no escribe en el DOM, no cancela eventos y no
     recarga nada. Solo lee y guarda. Si esto falla, la ficha sigue vendiendo igual.

     EL FORMATO ES EL MISMO QUE YA USAN EL QUIZ Y MAS VENDIDOS: {"n":"POCO F7 PRO",
     "h":"poco-f7-pro"}. La `h` sale de window.MCModelo.handle (snippets/micase-modelo
     .liquid), que es el handleize canonico del tema; el respaldo local es la misma
     logica, por si ese snippet no cargara. Si el formato no coincide, las secciones que
     lo leen no lo entienden.
     -------------------------------------------------------------------- */
  if (window.__mcSyncModelo) return;
  window.__mcSyncModelo = 1;

  function handle(s) {
    if (window.MCModelo && typeof window.MCModelo.handle === 'function') return window.MCModelo.handle(s);
    /* respaldo: misma logica, por si el snippet no cargo. El + pasa a la palabra plus
       ANTES de limpiar; sin eso "Pro + (5G)" y "Pro (5G)" quedan identicos y se
       siembra el handle equivocado en localStorage.micase_modelo. */
    return String(s == null ? '' : s).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Mismo recorrido que VariantSelects.getAllSelectedOptions() de Dawn. */
  function elegidas() {
    var vs = document.querySelector('variant-selects');
    var out = [];
    if (!vs) return out;
    var grupos = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (var i = 0; i < grupos.length; i++) {
      var marcado = grupos[i].querySelector('input:checked');
      if (!marcado) {
        var sel = grupos[i].querySelector('select');
        if (sel && sel.selectedIndex >= 0) marcado = sel.options[sel.selectedIndex];
      }
      if (marcado) {
        out.push({
          nombre: (marcado.dataset && marcado.dataset.optionName) || '',
          valor: marcado.value
        });
      }
    }
    return out;
  }

  function modeloElegido() {
    var l = elegidas(), i;
    for (i = 0; i < l.length; i++) {
      if (/odelo/i.test(l[i].nombre)) return l[i].valor;
    }
    /* Un solo grupo de opciones y se llama de otra forma: se acepta, es el modelo. */
    if (l.length === 1) return l[0].valor;
    return '';
  }

  function guarda() {
    var v = modeloElegido();
    if (!v) return;
    var actual = null;
    try { actual = JSON.parse(localStorage.getItem('micase_modelo') || 'null'); }
    catch (e) { actual = null; }
    if (actual && actual.n === v) return;
    var h = handle(v);
    if (!h) return;
    /* En el webview de Instagram entra el 35,3% del trafico y localStorage puede lanzar. */
    try {
      localStorage.setItem('micase_modelo', JSON.stringify({ n: v, h: h }));
      /* Avisar a los lectores de esta misma pagina (el prefijo de la insignia) de que
         el valor ya esta escrito. Ver el comentario junto al listener micase:modelo. */
      try { document.dispatchEvent(new CustomEvent('micase:modelo')); } catch (e2) {}
    }
    catch (e) { console.warn('[MIcase] micase-ajustes-dawn: no se pudo guardar en localStorage el modelo sincronizado con la variante', e); }
  }

  function arranca() {
    /* Solo en fichas de producto. Cubre /collections/x/products/y, que es una ficha
       completa; deja fuera el quick add de las colecciones, donde sembrar un modelo que
       nadie eligio corromperia lo que ven combo, costo, fotos y similares. */
    if (location.pathname.indexOf('/products/') === -1) return;
    if (!document.querySelector('variant-selects')) return;

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects')) setTimeout(guarda, 0);
    });

    /* MIcase 2026-08-11 · NO SE ESCRIBE EN LA CARGA. Antes arranca() llamaba a
       guarda() de entrada y el sondeo partia de ultimoId vacio: TODA visita a una
       ficha sembraba en micase_modelo el modelo de la variante por defecto, sin que
       nadie lo eligiera. Un visitante virgen veia la insignia en "Compatible con tu
       {por defecto}" — compatibilidad afirmada que no existe (regla dura de la
       matriz: sin guardado, PARA). Es el mismo veneno que el comentario de arriba
       prohibe para el quick add. Ahora el sondeo parte del valor ACTUAL (la primera
       vuelta es no-op) y solo escribe cuando el id de variante CAMBIA — un cambio
       real del cliente o la preseleccion desde su propio modelo guardado (que
       reescribe lo mismo). Encontrado el 2026-08-11 al correr el caso C de la
       matriz conducido de verdad (recarga incluida), bajo la regla 21. */
    /* MIcase 2026-08-22 · SE QUITA EL SONDEO DE 350 ms Y SE CONSERVA SU REGLA.
       Lo que hacia falta de verdad era la GUARDA de arriba: no escribir hasta que el id
       de variante CAMBIE. Eso se queda tal cual. Lo que sobraba era el reloj: Dawn ya
       avisa, y avisa DESPUES de haber escrito el input[name="id"], que es justo el dato
       que esta guarda compara (assets/product-info.js, updateVariantInputs + publish):

         1. publish(PUB_SUB_EVENTS.variantChange, ...)
         2. el propio input[name="id"] emite un `change` que burbuja hasta document
         3. 'product-info:loaded', para el cambio de PRODUCTO, donde Dawn reemplaza el
            <product-info> entero y no publica variantChange

       LA CARGA SIGUE SIN ESCRIBIR NADA. ultimoId parte del valor actual, igual que antes,
       y en una ficha recien abierta los tres avisos traen ese mismo id: no-op. El
       'product-info:loaded' inicial ni siquiera se alcanza a oir, porque el elemento se
       actualiza antes de DOMContentLoaded, que es cuando corre arranca().

       Con esto la ficha se queda sin ninguno de los dos relojes permanentes que tenia
       (este de 350 ms y el de 400 ms de assets/micase-despacho.js), que ademas vigilaban
       exactamente el mismo dato. */
    function idVariante() {
      var f = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return f ? String(f.value || '') : '';
    }
    var ultimoId = idVariante();
    function siCambioLaVariante() {
      var v = idVariante();
      if (v === ultimoId) return;
      ultimoId = v;
      guarda();
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, siCambioLaVariante);
      }
    } catch (e) { console.warn('[MIcase] micase-ajustes-dawn: no se pudo suscribir a variantChange del tema', e); }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id') siCambioLaVariante();
    });
    document.addEventListener('product-info:loaded', siCambioLaVariante);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();

/* ------------------------------------------------------------------
   3) micase-contador-carrito
   ------------------------------------------------------------------ */
(function () {
  /* --------------------------------------------------------------------
     EL NUMERO DEL CARRITO DE LA CABECERA. 2026-08-10.
     Sebastian: "cuando agrego un segundo producto al carrito, el contador
     no se actualiza; dentro del cajon si, pero el icono de fuera no".
     El tema refresca el cajon (y desde el 2026-08-10 tambien el que se
     agrega desde el cross-selling), pero el numero de la cabecera lo pinta
     Liquid en el servidor y nadie lo tocaba sin recargar.
     Aqui se engancha al bus comun window.MCcarrito, que ya relee /cart.js
     ante CUALQUIER cambio del carrito (boton de la ficha, cross-selling,
     combo, cajon, bfcache), y se escribe el numero exacto que responde
     Shopify. El nodo estable es [data-mc-contador], que micase-header
     pinta siempre (con hidden cuando esta en cero).
     -------------------------------------------------------------------- */
  /* OJO, ESTO NO ES OPCIONAL: el boton de compra de Dawn (assets/product-form.js)
     re-renderiza la seccion cart-icon-bubble e inyecta el marcado de Dawn DENTRO
     de #cart-icon-bubble, con lo que se lleva por delante el <span> propio de
     MIcase. Medido el 2026-08-10: tras pulsar "Anadir al carrito" el nodo
     [data-mc-contador] desaparecia y el numero se quedaba vacio. Por eso aqui no
     basta con escribir en el nodo: si no esta, se vuelve a crear. */
  /* MIcase 2026-08-11 · El CSS de sections/micase-header.liquid ancla la burbuja al
     .svg-wrapper que envuelve el glifo del carrito, no al enlace de 44px. Por eso el nodo
     tiene que vivir SIEMPRE dentro de ese envoltorio: colgando del enlace se colocaria
     respecto a la caja tactil y volveria a caer encima del dibujo. */
  function envoltorio(host) {
    return host.querySelector('.svg-wrapper') || host;
  }
  function nodo() {
    var host = document.getElementById('cart-icon-bubble') || document.querySelector('.mc-header__icono--carrito');
    var n = document.querySelector('[data-mc-contador]');
    if (n) {
      if (host) {
        var casa = envoltorio(host);
        if (n.parentNode !== casa) casa.appendChild(n);
      }
      return n;
    }
    if (!host) return null;
    // Marcado de Dawn recien inyectado. Su .cart-count-bubble trae su propio circulo
    // absoluto (base.css) y estorbaria al de MIcase, asi que se retira entera y se pinta
    // la nuestra dentro del envoltorio del glifo.
    var burbuja = host.querySelector('.cart-count-bubble');
    if (burbuja && burbuja.parentNode) burbuja.parentNode.removeChild(burbuja);
    var s = document.createElement('span');
    s.className = 'mc-header__contador cart-count-bubble';
    s.setAttribute('data-mc-contador', '');
    s.setAttribute('aria-hidden', 'true');
    envoltorio(host).appendChild(s);
    // El repintado de Dawn tambien se lleva el texto para lectores de pantalla: se repone.
    if (!document.querySelector('[data-mc-contador-texto]')) {
      var t = document.createElement('span');
      t.className = 'visually-hidden';
      t.setAttribute('data-mc-contador-texto', '');
      host.appendChild(t);
    }
    return s;
  }

  /* REBOTE AL CAMBIAR EL NUMERO. 2026-08-11.
     Se quita la clase, se fuerza un reflow leyendo offsetWidth y se vuelve a poner: sin esa
     lectura el navegador agrupa las dos escrituras, la clase nunca llega a salir del
     elemento y la animacion no se re-dispara en el segundo cambio seguido.
     La clase se retira en animationend para no dejarla puesta. */
  /* 2026-08-11 · EL REBOTE SOLO CUANDO EL NUMERO CAMBIA DE VERDAD.
     Antes se guardaba ademas `popPara` (el numero pendiente de rebotar) y cada nodo
     recordaba en __mcPopN si ya habia rebotado para ese numero. Efecto no deseado: cuando
     Dawn destruia la burbuja y el repaso de los 700 / 1600 ms la volvia a crear, el nodo
     NUEVO no tenia __mcPopN y rebotaba otra vez con el mismo numero. Esa era la segunda
     animacion que reportaba Sebastian. Ahora la unica referencia es `ultimo`, el ultimo
     numero PINTADO: recrear el nodo con el mismo numero no anima nada. */
  var ultimo = null;    /* ultimo numero pintado en esta pagina */
  function rebota(el) {
    if (!el || !el.classList) return;
    el.classList.remove('is-pop');
    void el.offsetWidth;
    el.classList.add('is-pop');
    if (!el.__mcPopLimpia) {
      el.__mcPopLimpia = 1;
      el.addEventListener('animationend', function () { el.classList.remove('is-pop'); });
    }
  }

  /* La referencia se toma del numero que ya venia pintado por el servidor, y se toma PRONTO.
     Si se esperara a la primera pasada de pinta(), Dawn podria haber destruido ya la burbuja
     (la recreamos vacia) y el numero anterior seria ilegible: el primer cambio real se
     quedaria sin rebote. */
  function siembra() {
    if (ultimo !== null) return;
    var a = document.querySelector('[data-mc-contador]');
    if (!a) return;
    var p = parseInt((a.textContent || '').trim(), 10);
    if (!isNaN(p)) ultimo = p;
  }

  function pinta(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    try {
      var uno = nodo();
      if (uno) {
        /* Primera pasada de la pagina: la referencia es lo que ya venia pintado desde el
           servidor, para que cargar la pagina no dispare el rebote. */
        var previo = (ultimo === null) ? parseInt((uno.textContent || '').trim(), 10) : ultimo;
        if (isNaN(previo)) previo = null;
        /* La decision se toma UNA vez, aqui: solo rebota si el numero nuevo es distinto del
           ultimo pintado. Las pasadas de los 700 / 1600 ms traen el mismo numero, asi que
           entran con cambia = false y no animan nada. */
        var cambia = (previo !== null && previo !== n);
        ultimo = n;
        var ns = document.querySelectorAll('[data-mc-contador]');
        for (var i = 0; i < ns.length; i++) {
          ns[i].textContent = n;
          if (n > 0) { ns[i].removeAttribute('hidden'); } else { ns[i].setAttribute('hidden', ''); }
          if (cambia && n > 0) rebota(ns[i]);
        }
      }
      var ts = document.querySelectorAll('[data-mc-contador-texto]');
      for (var j = 0; j < ts.length; j++) {
        ts[j].textContent = n + (n === 1 ? ' articulo en el carrito' : ' articulos en el carrito');
      }
    } catch (e) {
      console.warn('[MIcase] micase-ajustes-dawn: no se pudo actualizar el numero del carrito de la cabecera', e);
    }
  }
  /* Segunda red: si Dawn repinta el icono DESPUES de que hayamos escrito el
     numero, se vuelve a escribir leyendo el carrito real. Se hace con un
     temporizador corto tras cada aviso, no con un observador encadenado al
     marcado del tema (regla: no encadenar MutationObservers a los del tema). */
  function repite(n) { pinta(n); setTimeout(function () { pinta(n); }, 700); setTimeout(function () { pinta(n); }, 1600); }
  function engancha() {
    if (window.MCcarrito && typeof window.MCcarrito.on === 'function') {
      window.MCcarrito.on(function (c) { if (c && typeof c.item_count === 'number') repite(c.item_count); });
      return true;
    }
    return false;
  }
  siembra();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', siembra);
  if (!engancha()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', engancha);
    else setTimeout(engancha, 400);
  }
})();

/* ------------------------------------------------------------------
   4) micase-agotados-color
   ------------------------------------------------------------------ */
(function () {
  /* --------------------------------------------------------------------
     LOS COLORES AGOTADOS SE ESCONDEN POR JS, NO POR CSS. 2026-08-11.

     EL FALLO, MEDIDO en la ficha case-funda-forro-armadura-magnetico-camara-para-xiaomi
     -redmi-poco con el modelo POCO X6 PRO (Negro, Plateado y Azul agotados; Rojo
     disponible), sobre este mismo tema borrador: todo lo comprobable decia que la regla
     de CSS tenia que funcionar y no funcionaba.
       - el contenedor traia js product-form__input product-form__input--pill mc-op--color
       - los radios agotados traian la clase disabled
       - el hermano inmediato del radio era LABEL.mcsw
       - label.matches(".product-form__input--pill.mc-op--color input[type='radio'].disabled + label")
         devolvia true
       - la regla estaba en la hoja ya parseada
       - y aun asi label.getBoundingClientRect() daba 78x58 px: se seguian viendo.
     Tres intentos por CSS, tres fallos en la tienda real. Hay algo en la cascada que no
     se deja ver desde fuera, asi que se deja de discutir con la cascada.

     POR QUE ESTO SI CIERRA EL PROBLEMA: style.setProperty(...,'important') escribe estilo
     EN LINEA con !important. Esa es la capa mas alta que existe; no la gana ninguna regla
     de ninguna hoja, venga de donde venga y tenga la especificidad que tenga.

     LAS REGLAS DE CSS QUE YA HAY SE QUEDAN (.mcsw y .mc-op--color, mas arriba en este
     mismo archivo). No estorban y sirven de primera linea si este script no llegara a
     correr.

     TRES COSAS QUE NO SE PUEDEN CAMBIAR:
       1. Se esconde SOLO LA ETIQUETA, nunca el input. Dawn arma la peticion de variante
          desde fieldset input:checked (assets/global.js). Si el input desaparece del DOM,
          ese selector deja de encontrarlo y se rompe el cambio de variante.
       2. `&& !ins[i].checked`: si la opcion que esta seleccionada quedara marcada como
          agotada, no se esconde. Esconderla dejaria al cliente sin ver que tiene elegido.
       3. Solo se desescribe lo que escribio este script (data-mc-agotado). Asi no se pisa
          ningun display en linea que venga de otro sitio.

     POR QUE AQUI SI HAY MutationObserver, si la regla del proyecto dice que no: <variant-
     selects> se reemplaza ENTERO al cambiar de modelo, asi que el listener de change solo
     no basta: llega antes de que exista el marcado nuevo. Este observador no se encadena a
     ningun observador del tema, filtra por attributeFilter ['class'] y su callback no hace
     mas que reprogramar un temporizador de 40 ms. Y no se puede realimentar: lo que este
     script escribe es style y data-mc-agotado, que no estan en el filtro.

     NO TOCA EL SELECTOR DE MODELO. El gancho es .mc-op--color, que
     snippets/product-variant-options.liquid solo pone en la opcion de color. Un MODELO
     agotado tiene que seguir viendose para que el cliente sepa que existe.
     -------------------------------------------------------------------- */
  if (window.__mcAgotadosColor) return;
  window.__mcAgotadosColor = 1;

  /* --------------------------------------------------------------------
     PASO PREVIO: MOVER LA SELECCION FUERA DE UN COLOR AGOTADO. 2026-08-11.

     MEDIDO en la misma ficha (case-funda-forro-armadura-magnetico-camara-para-xiaomi
     -redmi-poco, modelo POCO X6 PRO): Negro llegaba disabled:true Y checked:true. La
     guarda `&& !ins[i].checked` de abajo lo respetaba a proposito, asi que el cliente
     veia justo lo que no queremos: un color agotado, y ademas como su seleccion actual.
     Pasa porque Dawn, al cambiar de modelo, conserva el valor de color anterior aunque
     esa combinacion ya no exista.

     Se arregla en el origen: si el color marcado esta agotado, se hace clic en el primer
     color disponible de esa misma caja, igual que lo haria el cliente. Ese clic hace que
     Dawn reemplace <variant-selects> entero, y el MutationObserver de mas abajo vuelve a
     llamar a limpia() sobre el arbol nuevo; por eso esa pasada se corta ahi mismo y no
     esconde nada.

     CUATRO COSAS QUE NO SE PUEDEN CAMBIAR:
       1. Si NO hay ningun color disponible (todos agotados para ese modelo) no se toca
          nada y tampoco se esconde ninguna etiqueta. Es preferible mostrar la verdad a
          dejar el selector vacio; ahi la guarda `&& !ins[i].checked` sigue siendo la red.
       2. Tope de 3 reasignaciones seguidas. Esto se auto-dispara (clic -> re-render ->
          limpia -> clic), asi que sin tope un catalogo raro podria dar vueltas sin fin.
          Agotado el tope se deja de intentar y se sigue como antes, sin romper nada.
       3. El contador solo se reinicia cuando una pasada termina SIN haber tenido que
          reasignar. Reiniciarlo en la pasada del tope devolveria el bucle.
       4. Nunca se quita un input del DOM, solo se hace click(). Dawn arma la peticion de
          variante desde fieldset input:checked.
     -------------------------------------------------------------------- */
  var mcReasignes = 0;

  function reasigna() {
    var cajas = document.querySelectorAll('.product-form__input--pill.mc-op--color');
    for (var c = 0; c < cajas.length; c++) {
      var ins = cajas[c].querySelectorAll("input[type='radio']");
      var sel = null;
      for (var i = 0; i < ins.length; i++) {
        if (ins[i].checked) { sel = ins[i]; break; }
      }
      if (!sel) continue;
      if (!(sel.classList.contains('disabled') || sel.disabled)) continue;
      var libre = null;
      for (var j = 0; j < ins.length; j++) {
        if (!ins[j].classList.contains('disabled') && !ins[j].disabled) { libre = ins[j]; break; }
      }
      if (!libre) return 'sin-salida';
      if (mcReasignes >= 3) return 'tope';
      mcReasignes++;
      libre.click();
      return 'movido';
    }
    return 'nada';
  }

  function limpia() {
    try {
      var paso = reasigna();
      /* El clic ya disparo el re-render: el observador volvera a llamar aqui. */
      if (paso === 'movido') return;
      /* Todos agotados: no se esconde nada y la seleccion se queda como esta. */
      if (paso === 'sin-salida') return;
      var cajas = document.querySelectorAll('.product-form__input--pill.mc-op--color');
      for (var c = 0; c < cajas.length; c++) {
        var ins = cajas[c].querySelectorAll("input[type='radio']");
        for (var i = 0; i < ins.length; i++) {
          var lab = ins[i].nextElementSibling;
          if (!lab || lab.tagName !== 'LABEL') continue;
          var fuera = ins[i].classList.contains('disabled') || ins[i].disabled;
          if (fuera && !ins[i].checked) {
            lab.style.setProperty('display', 'none', 'important');
            lab.setAttribute('data-mc-agotado', '');
          } else if (lab.hasAttribute('data-mc-agotado')) {
            lab.style.removeProperty('display');
            lab.removeAttribute('data-mc-agotado');
          }
        }
      }
      if (paso === 'nada') mcReasignes = 0;
    } catch (e) {}
  }

  function vigila() {
    try {
      if (!window.MutationObserver) return true;
      var raiz = document.querySelector('.product__info-container') || document.body;
      if (!raiz) return false;
      var mo = new MutationObserver(function () {
        clearTimeout(window.__mcAgotadoT);
        window.__mcAgotadoT = setTimeout(limpia, 40);
      });
      mo.observe(raiz, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      return true;
    } catch (e) {
      return true;
    }
  }

  limpia();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', limpia);

  /* Se escucha en captura y filtrado por variant-selects, igual que hace micase-modelo-sync:
     es el mismo evento que escucha el propio VariantSelects, asi que existe siempre. Los
     60 ms son para llegar DESPUES de que Dawn haya repintado la seccion. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(limpia, 60);
  }, true);

  if (!vigila() && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigila);
})();